import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core';

import Block from 'components/Block';

import styles from './styles';

const enhancer = compose(withStyles(styles));

const Step = () => {
  return (
    <>
      <Block headline="Step 1"></Block>
    </>
  );
};

export default enhancer(Step);
